import { FC } from 'react';
import { css } from '@emotion/react';
import { spacing, colors } from '../../../styles';
import { ToolRendererProps } from './types';

export const SearchResultsRenderer: FC<ToolRendererProps> = ({ output, isLoading }) => {
  if (isLoading) {
    return (
      <div
        css={css`
          font-size: 14px;
          color: ${colors.silver};
        `}
      >
        Searching stocks...
      </div>
    );
  }

  const results = output.results || output.data;

  if (!results) {
    return (
      <div
        css={css`
          font-size: 14px;
          color: ${colors.silver};
        `}
      >
        Search completed
      </div>
    );
  }

  // Handle array format (from MCP tools) or object format
  let symbols: string[] = [];
  if (Array.isArray(results)) {
    symbols = results.map((item: any) => item.symbol).filter(Boolean);
  } else if (typeof results === 'object') {
    symbols = Object.keys(results);
  }

  if (symbols.length === 0) {
    return (
      <div
        css={css`
          font-size: 14px;
          color: ${colors.silver};
        `}
      >
        No symbols found
      </div>
    );
  }

  return (
    <div
      css={css`
        margin: ${spacing.centi} 0 0 0;
      `}
    >
      <div
        css={css`
          font-size: 12px;
          color: ${colors.silver};
          margin-bottom: ${spacing.centi};
        `}
      >
        Found {symbols.length} {symbols.length === 1 ? 'symbol' : 'symbols'}
      </div>
      <div
        css={css`
          font-size: 14px;
          line-height: 1.4;
        `}
      >
        {symbols.map((symbol, index) => (
          <span key={symbol}>
            <span
              css={css`
                color: ${colors.petrolBlue};
                font-weight: 500;
                cursor: pointer;
                text-decoration: none;

                &:hover {
                  text-decoration: underline;
                }

                html[data-theme='dark'] & {
                  color: ${colors.skyBlue};
                }
              `}
              onClick={() => {
                // Navigate to symbol page
                window.location.href = `/symbol/${symbol}`;
              }}
            >
              {symbol}
            </span>
            {index < symbols.length - 1 && (
              <span
                css={css`
                  color: ${colors.silver};
                  margin: 0 ${spacing.milli};
                `}
              >
                ,
              </span>
            )}
          </span>
        ))}
      </div>
    </div>
  );
};
